import type { AlgoliaProductHit, AlgoliaPromoCardHit } from "~/lib/algolia/types"

export function isPromoCardHit(hit: AlgoliaProductHit | AlgoliaPromoCardHit): hit is AlgoliaPromoCardHit {
  return hit?.type === "promo_card"
}

export function isProductCardHit(hit: AlgoliaProductHit | AlgoliaPromoCardHit): hit is AlgoliaProductHit {
  return hit?.type === "product"
}
